/**
 * Trang xem thử ba nhãn nhắc trên đơn (spec 4.4) — chỉ chạy ở bản phát triển,
 * `_dev` tự chặn ở bản phát hành.
 *
 * Vì sao đáng có: nhãn nằm xen giữa các chip sẵn có trên MỘT dòng ngang, nên
 * thứ dễ hỏng nhất không phải màu sắc mà là bố cục ở màn hẹp và khi một đơn
 * bật cùng lúc cả ba nhãn. Bài kiểm khẳng định được "có hiện", nhưng không
 * thay được việc nhìn.
 */
import { createFileRoute } from "@tanstack/react-router";

import { PageHeader } from "@/components/PageHeader";
import { OrderTable } from "@/features/orders/components/OrderTable";
import { OrderMobileList } from "@/features/orders/components/OrderMobileList";
import type { OrderSummary, OrderAttentionFlags } from "@/features/orders/api";

export const Route = createFileRoute("/_dev/attention")({
  component: AttentionDemo,
});

const don = (id: string, code: string, customer: string, extra: Partial<OrderSummary> = {}) =>
  ({
    id,
    code,
    customer,
    phone: "0901 234 567",
    product: "pf_basic",
    branch: "hn_01",
    status: "editing",
    shootDate: "2026-08-20",
    total: 5_000_000,
    deposit: 1_000_000,
    costumeExtra: 0,
    tags: [],
    ...extra,
  }) as unknown as OrderSummary;

const orders: OrderSummary[] = [
  don("o-sach", "PF-1001", "Đơn sạch — không nhãn nào"),
  don("o-no", "PF-1002", "Chị Hoa"),
  don("o-makeup", "PF-1003", "Anh Nam"),
  don("o-hau", "PF-1004", "Chị Mai"),
  don("o-ba", "PF-1005", "Cô Lan — cả ba việc cùng lúc"),
];

const flags: OrderAttentionFlags = {
  "o-no": { debtRemaining: 2_500_000, postCheckPending: false },
  "o-makeup": { makeupProofMissing: ["Hà", "Linh"], debtRemaining: 0, postCheckPending: false },
  "o-hau": { debtRemaining: 0, postCheckPending: true },
  "o-ba": {
    makeupProofMissing: ["Hà"],
    debtRemaining: 750_000,
    postCheckPending: true,
  },
};

function AttentionDemo() {
  return (
    <div className="space-y-6 p-8" data-testid="attention-demo">
      <PageHeader
        title="Nhãn nhắc trên đơn"
        description="Ba nhãn chỉ NHẮC, không chặn thao tác nào — spec 4.4, CEO duyệt 24/08/2026"
      />
      <section className="space-y-2">
        <h2 className="text-sm font-semibold text-muted-foreground">Bảng (máy tính)</h2>
        <OrderTable orders={orders} attentionFlags={flags} />
      </section>

      {/* Màn hẹp KHÔNG dùng bảng — OrdersListView đổi sang danh sách thẻ. Xem
          cả hai ở đây để bố cục màn nhỏ được nhìn bằng đúng thứ người dùng
          thấy, chứ không phải bằng bảng bị bóp lại. */}
      <section className="space-y-2">
        <h2 className="text-sm font-semibold text-muted-foreground">Danh sách thẻ (điện thoại)</h2>
        <div className="max-w-[390px] rounded-lg border">
          <OrderMobileList orders={orders} onRefresh={() => {}} attentionFlags={flags} />
        </div>
      </section>
    </div>
  );
}
